























































































































































import { Component, Vue } from "vue-property-decorator";
import BerkasRmService, {
  JenisBerkasManage,
  JenisBerkasPayload
} from "@/services/BerkasRmService";
import ErrorAlert from "@/utility/ErrorAlert";

@Component
export default class PanelKelolaJenisBerkas extends Vue {
  items: JenisBerkasManage[] = [];
  loading = false;
  saving = false;

  formDialog = false;
  deleteDialog = false;
  editingId: number | null = null;
  toDelete: JenisBerkasManage | null = null;
  errors: Record<string, string[]> = {};

  form: JenisBerkasPayload = this.emptyForm();

  headers = [
    { text: "Kode", value: "kode", width: 180 },
    { text: "Label", value: "label" },
    { text: "Induk", value: "parent_id", width: 200 },
    { text: "Urutan", value: "urutan", width: 90, align: "center" },
    { text: "Dipakai", value: "berkas_count", width: 90, align: "center" },
    { text: "Status", value: "aktif", width: 110 },
    { text: "", value: "actions", sortable: false, width: 90 }
  ];

  mounted() {
    this.loadData();
  }

  emptyForm(): JenisBerkasPayload {
    return {
      kode: "",
      label: "",
      urutan: 0,
      aktif: true,
      parent_id: null
    };
  }

  get indukOptions(): JenisBerkasManage[] {
    return this.items.filter(
      i => i.parent_id === null && i.id !== this.editingId
    );
  }

  get punyaAnak(): boolean {
    if (!this.editingId) return false;
    return this.items.some(i => i.parent_id === this.editingId);
  }

  labelInduk(item: JenisBerkasManage): string {
    const induk = this.items.find(i => i.id === item.parent_id);
    return induk ? induk.label : "—";
  }

  bisaHapus(item: JenisBerkasManage): boolean {
    return this.jumlahPakai(item) === 0 && this.jumlahAnak(item) === 0;
  }

  alasanHapus(item: JenisBerkasManage): string {
    if (this.jumlahPakai(item) > 0)
      return "Sudah dipakai berkas — nonaktifkan saja";
    if (this.jumlahAnak(item) > 0)
      return "Masih memiliki subkategori — pindahkan atau hapus subkategorinya dulu";
    return "Hapus";
  }

  private jumlahPakai(item: JenisBerkasManage): number {
    return Number(item.berkas_count || 0);
  }

  private jumlahAnak(item: JenisBerkasManage): number {
    return Number(item.children_count || 0);
  }

  async loadData() {
    this.loading = true;
    try {
      this.items = await BerkasRmService.listJenisBerkasManage();
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.editingId = null;
    this.form = this.emptyForm();
    this.errors = {};
    this.formDialog = true;
  }

  openEdit(item: JenisBerkasManage) {
    this.editingId = item.id;
    this.form = {
      kode: item.kode,
      label: item.label,
      urutan: item.urutan,
      aktif: item.aktif,
      parent_id: item.parent_id
    };
    this.errors = {};
    this.formDialog = true;
  }

  async save() {
    this.saving = true;
    this.errors = {};
    try {
      if (this.editingId) {
        await BerkasRmService.updateJenisBerkas(this.editingId, this.form);
      } else {
        await BerkasRmService.createJenisBerkas(this.form);
      }
      this.formDialog = false;
      await this.loadData();
      this.$emit("changed");
    } catch (e) {
      const err = e as any;
      if (err?.response?.data?.errors) {
        this.errors = err.response.data.errors;
      } else {
        ErrorAlert.showErrorAlert(err);
      }
    } finally {
      this.saving = false;
    }
  }

  confirmDelete(item: JenisBerkasManage) {
    this.toDelete = item;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    this.saving = true;
    try {
      await BerkasRmService.deleteJenisBerkas(this.toDelete.id);
      this.deleteDialog = false;
      this.toDelete = null;
      await this.loadData();
      this.$emit("changed");
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
    } finally {
      this.saving = false;
    }
  }
}
